export default __webpack_public_path__ + "static/media/Knivsta_full.342b4931.png";